import { Application } from '../../helpers/app'
// import 'regenerator-runtime/runtime'
import '../../components/hero/hero.component'
import '../../components/features/features.component'
import '../../components/vaults-about/vaults-about.component'
import '../../components/partners/partners.component'
import '../../components/reviews/reviews.component'
import '../../components/subscribe/subscribe.component'
import '../../components/regular-section/regular-section.component'
// import './vaults.pug'
import './vaults.scss'
Application.run()

